export default {
  data() {
    return {
      soundStatus: 'on',
      notificationSound: new Audio('/static/audio/whatsapp_web_tone.mp3'),
    };
  },
  mounted() {
    if (this.$cookies.isKey('notification_sound')) {
      this.soundStatus = this.$cookies.get('notification_sound');
    } else {
      this.$cookies.set('notification_sound', 'on', '1y');
    }

    this.$eventBus.$on('notificationSoundSwitched', (soundStatus) => {
      this.soundStatus = soundStatus;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('notificationSoundSwitched');
  },
  methods: {
    notifySound() {
      if (this.soundStatus === 'on') {
        this.notificationSound.volume = 0.1;
        this.notificationSound.play().catch(() => {
          // do nothing if there is an error to play sound before user interaction with page
        });
      }
    },
  },
};
